import React from 'react'
import { DiscountLabel, PricePerUom, ProductAvatar } from '@ztechapps/product.webui'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import { formatMoney, truncate } from '@ztechapps/common.utils'
import type { Product } from '@ztechapps/common.contract'
import { LinkToProductItem } from '../../../../components/Links/LinkToProductItem'
import { ShowIf, TooltipPopOver } from '@ztechapps/webui.util'

export const ListRow = (props: BodyRowConfig<Product>) => {
  const {
    _id,
    code,
    name,
    price,
    coverImage,
    coverImageThumb,
    metadataObject,
    originalPrice,
    discountPercentage,
    orderUom,
  } = props

  const { verticalIn, horizontalIn, horizontalMm, verticalMm } = metadataObject ?? {}

  return (
    <>
      <RowNumberBodyCell {...props} />
      {props._renderDataBodyCell({
        code: (
          <div className="fw-bold">
            <LinkToProductItem _id={_id} productCode={code}>
              {code}
            </LinkToProductItem>
          </div>
        ),
        name: (
          <TooltipPopOver tooltipBody={name}>
            <small>{truncate(name, 50)}</small>
          </TooltipPopOver>
        ),
        price: (
          <>
            <div className="text-end">
              <PricePerUom price={price} uom={orderUom?.name} />
            </div>
            <ShowIf condition={originalPrice > price}>
              <div className="text-end fw-bold">
                <small className="text-decoration-line-through">{formatMoney(originalPrice)}</small>
              </div>
            </ShowIf>

            <DiscountLabel discountPercentage={discountPercentage} />
          </>
        ),
        coverImage: <ProductAvatar name={name} coverImage={coverImage} coverImageThumb={coverImageThumb} />,
        verticalIn: <SizeDisplay value={verticalIn as number} unit="in" />,
        horizontalIn: <SizeDisplay value={horizontalIn as number} unit="in" />,
        verticalMm: <SizeDisplay value={verticalMm as number} unit="mm" />,
        horizontalMm: <SizeDisplay value={horizontalMm as number} unit="mm" />,
      })}
    </>
  )
}

const SizeDisplay = ({ value, unit }: { value: number | null; unit: 'mm' | 'in' }) => {
  return (
    <ShowIf condition={!!value}>
      <div className="text-end">
        {value} {unit}.
      </div>
    </ShowIf>
  )
}
